module.exports = __webpack_public_path__ + "static/media/slide_two.b81e0ae3.jpg";